import { render, staticRenderFns } from "./ConfigurationDiscountItemRow.vue?vue&type=template&id=d92c1cca&"
import script from "./ConfigurationDiscountItemRow.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationDiscountItemRow.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationDiscountItemRow.vue?vue&type=style&index=0&id=d92c1cca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports